<template>
    <div :class="'content-line-multiple content-line-multiple-textbild '
    +(content.Bildposition==='Links'?'content-line-multiple-image-left':'')" :id="content.Anker">
        <div class="content-line-cell content-line-cell-image" :style="'width:'+(100 - content.ratio)+'%;'">
            <Text :content="content.Text"/>
        </div>
        <div class="content-line-cell content-line-cell-text" :style="'width:'+content.ratio+'%;'">
            <Bild :content="content.Bild"/>
        </div>
    </div>
</template>

<script>
import Bild from "@/components/elements/Bild.vue";
import Text from "@/components/elements/Text.vue";

export default {
    components: {Text, Bild},
    props: [
        "content"
    ],
}
</script>